import React from 'react';

function ChatTwo(props: object) {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.9" clip-path="url(#clip0_14520_31468)">
        <path
          d="M27.921 13.4626C35.5899 13.3455 41.8492 19.3814 41.9977 27.0498C42.0195 28.1756 41.907 29.2715 41.6751 30.3226C41.2825 32.1025 41.0492 33.9136 41.0492 35.7363V39.2593C41.0492 39.7991 40.6116 40.2367 40.0718 40.2367H36.5488C34.7261 40.2367 32.915 40.47 31.1351 40.8626C30.0841 41.0945 28.9882 41.207 27.8623 41.1852C20.1941 41.0368 14.1581 34.7777 14.2751 27.1089C14.3892 19.6236 20.4357 13.577 27.921 13.4626Z"
          fill="#FCFCFC"
        />
        <path
          opacity="0.3"
          d="M27.921 13.4626C35.5899 13.3455 41.8492 19.3814 41.9977 27.0498C42.0195 28.1756 41.907 29.2715 41.6751 30.3226C41.2825 32.1025 41.0492 33.9136 41.0492 35.7363V39.2593C41.0492 39.7991 40.6116 40.2367 40.0718 40.2367H36.5488C34.7261 40.2367 32.915 40.47 31.1351 40.8626C30.0841 41.0945 28.9882 41.207 27.8623 41.1852C20.1941 41.0368 14.1581 34.7777 14.2751 27.1089C14.3892 19.6236 20.4357 13.577 27.921 13.4626Z"
          fill="#006AF9"
        />
        <path
          d="M17.1526 0.814543C7.80972 0.671809 0.184189 8.02516 0.00322869 17.3674C-0.0232674 18.7388 0.113807 20.0741 0.396322 21.3546C0.874563 23.5228 1.15888 25.7294 1.15888 27.9499V32.2419C1.15888 32.8994 1.69192 33.4326 2.34956 33.4326H6.64159C8.86201 33.4326 11.0686 33.7169 13.2369 34.1951C14.5174 34.4776 15.8525 34.6147 17.224 34.5881C26.566 34.4073 33.9194 26.782 33.777 17.4393C33.6379 8.32014 26.2716 0.95375 17.1526 0.814543Z"
          fill="#DC00FE"
        />
        <path
          d="M10.8439 16.7941C10.3668 16.2871 9.69151 15.9688 8.94027 15.9688C7.49546 15.9688 6.32422 17.14 6.32422 18.5848C6.32422 19.336 6.6425 20.0112 7.14953 20.4884L12.7928 26.1317C13.27 26.6386 13.9452 26.957 14.6964 26.957C16.1412 26.957 17.3124 25.7857 17.3124 24.3409C17.3124 23.5898 16.9941 22.9145 16.4871 22.4373L10.8439 16.7941Z"
          fill="#DC00FE"
        />
        <path
          d="M8.94027 21.2009C10.3851 21.2009 11.5563 20.0296 11.5563 18.5848C11.5563 17.14 10.3851 15.9688 8.94027 15.9688C7.49547 15.9688 6.32422 17.14 6.32422 18.5848C6.32422 20.0296 7.49547 21.2009 8.94027 21.2009Z"
          fill="white"
        />
        <path
          d="M18.2423 16.7941C17.7652 16.2871 17.09 15.9688 16.3387 15.9688C14.8939 15.9688 13.7227 17.14 13.7227 18.5848C13.7227 19.336 14.0409 20.0112 14.548 20.4884L20.1912 26.1317C20.6684 26.6386 21.3437 26.957 22.0948 26.957C23.5396 26.957 24.7109 25.7857 24.7109 24.3409C24.7109 23.5898 24.3925 22.9145 23.8856 22.4373L18.2423 16.7941Z"
          fill="#DC00FE"
        />
        <path
          d="M16.3387 21.2009C17.7835 21.2009 18.9548 20.0296 18.9548 18.5848C18.9548 17.14 17.7835 15.9688 16.3387 15.9688C14.8939 15.9688 13.7227 17.14 13.7227 18.5848C13.7227 20.0296 14.8939 21.2009 16.3387 21.2009Z"
          fill="white"
        />
        <path
          d="M25.6408 16.7941C25.1637 16.2871 24.4884 15.9688 23.7371 15.9688C22.2923 15.9688 21.1211 17.14 21.1211 18.5848C21.1211 19.336 21.4395 20.0112 21.9464 20.4884L27.5897 26.1317C28.0668 26.6386 28.7421 26.957 29.4933 26.957C30.9381 26.957 32.1093 25.7857 32.1093 24.3409C32.1093 23.5898 31.791 22.9145 31.284 22.4373L25.6408 16.7941Z"
          fill="#DC00FE"
        />
        <path
          d="M23.7371 21.2009C25.182 21.2009 26.3532 20.0296 26.3532 18.5848C26.3532 17.14 25.182 15.9688 23.7371 15.9688C22.2923 15.9688 21.1211 17.14 21.1211 18.5848C21.1211 20.0296 22.2923 21.2009 23.7371 21.2009Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_14520_31468">
          <rect width="42" height="42" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ChatTwo;
